/**
 * Per-device conveniences only (theme, last language before sign-in). Storage can be missing or throw (private
 * windows, blocked site data), so every access is guarded and the app works without it. Never tokens.
 */
export function readDevice(key: string): string | undefined {
  try {
    return globalThis.localStorage.getItem(`commerce-os.${key}`) ?? undefined;
  } catch {
    return undefined;
  }
}

export function writeDevice(key: string, value: string): void {
  try {
    globalThis.localStorage.setItem(`commerce-os.${key}`, value);
  } catch {
    // Not saved: the choice still applies for this visit.
  }
}
